import json from './sprite.js';

export default {
    handle: 'ENG_SPS4-Pants',
    label: 'en_SPS4-Pants_225002423',
    json,
};
